import i18next from "i18next";
import i18n from '../../.././config/i18n/i18n';

export default function translateLabel( value ) {
    const t = i18n.t.bind(i18next);
    return t(value)
}

